import { createTwStyle, joinCn } from '../util';
import { TOAST_VARIANT } from './constant';
import type { VToastProps } from './type';

const twStyle = createTwStyle<VToastProps>();

export default twStyle({
  baseItem: ({ toast: { variant } }) => {
    return joinCn('w-fit rounded-md px-4 py-2 shadow-sm', {
      'bg-error-100': variant === TOAST_VARIANT.ERROR,
      'bg-info-100': variant === TOAST_VARIANT.INFO,
      'bg-success-100': variant === TOAST_VARIANT.SUCCESS,
      'bg-warning-100': variant === TOAST_VARIANT.WARNING,
    });
  },
  icon: joinCn('size-4'),
});
